<template>
  <div class="navContainer" >
    <el-row :gutter="24" style="margin: 0;z-index: 100">
      <el-col :offset="4" :span="7" >
        <Logo ></Logo>
      </el-col>
      <el-col :offset="0" :span="9" class="flexRowClass">
        <div v-for="(item, index) in titleList" :key="index" :class="isActiveTitle === item.path ? 'activeClass' : ''" class="titleClass" @click="titleClick(item)">{{ item.title }}</div>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import Logo from './Logo'

export default {
  components: { Logo },
  watch: {
    $route: function (newQuestion) {
     this.changeActiveTitle(newQuestion)
    }
  },
  data() {
    return {
      titleList : [
        {
          title: '网站首页',
          path: '/',
        },
        {
          title: '交易信息',
          path: '/transactionInformation'
        },
        {
          title: '帮助中心',
          path: '/helpCenter'
        },
        {
          title: '下载中心',
          path: '/downloadCenter'
        },
        {
          title: '关于我们',
          path: '/aboutUs'
        },
        // {
        //   title: '联系我们',
        //   path: '/contact'
        // },
      ],
      isActiveTitle: '/'
    }
  },
  mounted() {
    this.changeActiveTitle(this.$route)
  },
  methods: {
    titleClick(item) {
      // console.log('this.$route', this.$route)
      if(item.title === '联系我们'){
        window.open('http://eedsgq.86ztb.com/manager.htm?htm=showNewsToUs&type=268&pf=eedsgq')
      }else {
        if (this.$route.fullPath !== item.path) {
          this.$router.push(item.path)
        }
      }
    },
    changeActiveTitle(item){
      if (item.fullPath === '/') {
        // this.setIsActive('test')
        this.isActiveTitle = '/'
      } else {
        this.isActiveTitle = `/${item.fullPath.split('/')[1]}`
      }
    }
  }
}
</script>

<style scoped>

.navContainer {
  width: 100%;
  background-color: #0E9EFF;
  height: 100px;
  line-height: 100px;
}

.titleClass {
  color: #fff;
  //font-size: 18px;
  margin: 0 20px;
  /*width: 120px;*/
  height: 60px;
  cursor: pointer;
  text-align: center;
  z-index: 100;
}

.activeClass {
  /*background: red;*/
  color: #fff;
  font-weight: 600;
  border-bottom: 4px solid #fff;
}

</style>